function elementsToMaxHeight(elements)
{
  let height = 1
  elements.each(function (){
    let thisHeight = $(this).outerHeight(true)
    height = thisHeight > height ? thisHeight : height
  })

  elements.css('height', `${height}px`)
}

export { elementsToMaxHeight }
